import { createI18n } from "vue-i18n";

import { useLocalesStore } from "@/entities";

export const withI18n = async (app) => {
    const localeStore = useLocalesStore();

    await localeStore.initLanguages();
    await localeStore.getManyTranslation(localeStore.currentLocale);

    const i18n = createI18n({
        legacy: false,
        locale: localeStore.currentLocale,
        fallbackLocale: "ru",
        messages: {
            [localeStore.currentLocale]:
                localeStore.translations[localeStore.currentLocale],
        },
    });

    app.use(i18n);
};
